import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import {createSelectOptions, formatTelefone, getByAtribute} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";

@inject("store")
@observer
export class DetalhamentoIndicacoes extends Component {

    static propTypes = {
    };

    constructor(props) {
        super(props);
    }

    render() {
        const solicitacao = this.props.controller.solicitacao;
        const exibeSubtituloIndicacao = this.props.controller.exibeSubtituloIndicacao;
        const exibeIndicacaoEtt = this.props.controller.exibeIndicacaoEtt;
        const tituloIndicacao = this.props.controller.tituloIndicacao;
        const exibeAvisoIndicacaoNaoReivindicada = this.props.controller.exibeAvisoIndicacaoNaoReivindicada;
        const indicacoesForm = [];

        for (let i = 0; i < _.get(solicitacao, "indicacoes.length", 0); i++) {
            if(i === 0 || !solicitacao.solicitacaoExcecao) {
                indicacoesForm.push(<div key={i}>
                    {exibeSubtituloIndicacao &&
                    <div>
                        <div className="form-subtitle">
                            <span className="subtitle">Indicação {i + 1}</span>
                        </div>
                        <hr className="form-subtitle"/>
                    </div>
                    }
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>CPF</Label>
                                <NumberFormat className="form-control" format="###.###.###-##" value={_.get(solicitacao, "indicacoes["+i+"].cpf")} readOnly/>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Nome</Label>
                                <Input type="text" value={_.get(solicitacao, "indicacoes["+i+"].nome")} readOnly/>
                            </FormGroup>
                        </Col>
                        {exibeIndicacaoEtt &&
                            <Col xs={12} md={6} lg={4}>
                                <FormGroup>
                                    <Label>ETT</Label>
                                    <Input type="text" value={_.get(solicitacao, "indicacoes["+i+"].ett.nomeFantasia")} readOnly/>
                                </FormGroup>
                            </Col>
                        }
                    </Row>
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>E-mail</Label>
                                <Input type="text" value={_.get(solicitacao, "indicacoes["+i+"].email")} readOnly/>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Telefone contato</Label>
                                <NumberFormat className="form-control" maxLength={15} format={(value) => formatTelefone(value)} value={_.get(solicitacao ,"indicacoes["+i+"].telefone")} readOnly/>
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
                )
            }
        }

        return (
            <div>
                <h4>{tituloIndicacao}</h4>
                {exibeAvisoIndicacaoNaoReivindicada ? (
                    <span>A indicação só poderá ser visualizada após reivindicar.</span>
                ) : (
                    <div>
                        {indicacoesForm}
                    </div>
                )}
            </div>
        )
    }
}